import React from 'react';

/**
 * Inline formatting for chat text: markdown links (also when the model breaks the
 * line between "[text]" and "(url)"), bare http(s) URLs and **bold**. Builds React
 * elements only, so nothing in a message is ever rendered as HTML; links are
 * limited to http(s) and open in a new tab.
 */
const TOKEN = /\[([^\]\n]{1,300})\]\s*\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s<>()]+[^\s<>().,;:!?'"])|\*\*([^*\n]{1,300})\*\*/g;

const linkStyle: React.CSSProperties = { color: '#fec35c', textDecoration: 'underline', wordBreak: 'break-word' };

export function formatInline(text: string, keyPrefix: string): (string | JSX.Element)[] {
  const out: (string | JSX.Element)[] = [];
  let last = 0;
  let m: RegExpExecArray | null;
  TOKEN.lastIndex = 0;
  while ((m = TOKEN.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const key = `${keyPrefix}-${m.index}`;
    if (m[2]) {
      out.push(<a key={key} href={m[2]} target="_blank" rel="noopener noreferrer" style={linkStyle}>{m[1]}</a>);
    } else if (m[3]) {
      out.push(<a key={key} href={m[3]} target="_blank" rel="noopener noreferrer" style={linkStyle}>{m[3]}</a>);
    } else {
      out.push(<strong key={key}>{m[4]}</strong>);
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
